<template>
  <div>
    <Tabs type="card" :value="tabValue" @on-click="cutoverTab">
      <TabPane label="资产查询" name="assetsTab">
        <Modal title="表头重置" v-model="tableColModal">
          <!-- <Checkbox-group v-model="asset.tableColumns">
            <Checkbox :label="item.key" v-for="item in asset.columns" :key="item.key" v-if="item.key">{{ item.title }}</Checkbox>
          </Checkbox-group> -->
           <Alert type="warning">1 鼠标按住不放可拖动列顺序 2 要展示的列需选中</Alert>
          <Table draggable :columns="asset.orderColumn" :data="asset.orderColumnData" height="460" @on-drag-drop="onDragDrop"></Table>
          <div slot="footer">
            <Button @click="handleSelectAll(true)">全选</Button>
            <Button @click="handleSelectAll(false)">取消全选</Button>
            <Button type="primary" :loading="saveShowColConfiging" style="margin-right: 8px" icon="md-checkmark" @click="saveShowColConfig">保存</Button>
            <Button @click="tableColModal = false">取消</Button>
          </div>
        </Modal>
        <Modal v-model="lendModal" @on-cancel="formReset('lendForm')">
          <p slot="header">
            <span>资产借出</span>
          </p>
          <div style="text-align:center">
            <Form ref="lendForm" :model="lendForm" :label-width="70" :rules="lendRule">
              <FormItem label="资产编号" prop="asset_id">
                <Input v-model="lendForm.asset_id" />
              </FormItem>
              <FormItem label="保管人" prop="hand_person">
                <Input v-model="lendForm.hand_person" />
              </FormItem>
              <FormItem label="备注" prop="remark">
                <Input type="textarea" v-model="lendForm.remark" />
              </FormItem>
            </Form>
          </div>
          <div slot="footer">
            <Button type="primary" size="large" @click="lendAction">借出</Button>
          </div>
        </Modal>
        <Modal v-model="returnModal" @on-cancel="formReset('returnForm')">
          <p slot="header">
            <span>资产归还</span>
          </p>
          <div style="text-align:center">
            <Form ref="returnForm" :model="returnForm" :label-width="70" :rules="returnRule">
              <FormItem label="资产编号" prop="asset_id">
                <Input v-model="returnForm.asset_id" />
              </FormItem>
              <FormItem label="归还人" prop="hand_person">
                <Input v-model="returnForm.hand_person" />
              </FormItem>
              <FormItem label="备注" prop="remark">
                <Input type="textarea" v-model="returnForm.remark" />
              </FormItem>
            </Form>
          </div>
          <div slot="footer">
            <Button type="primary" size="large" @click="returnAction">归还</Button>
          </div>
        </Modal>
        <Modal v-model="maintainModal" @on-cancel="formReset('maintainForm')">
          <p slot="header">
            <span>资产维修</span>
          </p>
          <div style="text-align:center">
            <Form ref="maintainForm" :model="maintainForm" :label-width="70" :rules="maintainRule">
              <FormItem label="资产编号" prop="asset_id">
                <Input v-model="maintainForm.asset_id" />
              </FormItem>
              <FormItem label="维修方" prop="hand_person">
                <Input v-model="maintainForm.hand_person" />
              </FormItem>
              <FormItem label="备注" prop="remark">
                <Input type="textarea" v-model="maintainForm.remark" />
              </FormItem>
            </Form>
          </div>
          <div slot="footer">
            <Button type="primary" size="large" @click="maintainAction">维修</Button>
          </div>
        </Modal>
        <Modal v-model="scrapModal" @on-cancel="formReset('scrapForm')">
          <p slot="header">
            <span>资产报销</span>
          </p>
          <div style="text-align:center">
            <Form ref="scrapForm" :model="scrapForm" :label-width="70" :rules="scrapRule">
              <FormItem label="资产编号" prop="asset_id">
                <Input v-model="scrapForm.asset_id" />
              </FormItem>
              <FormItem label="备注" prop="remark">
                <Input type="textarea" v-model="scrapForm.remark" />
              </FormItem>
            </Form>
          </div>
          <div slot="footer">
            <Button type="primary" size="large" @click="scrapAction">报销</Button>
          </div>
        </Modal>
        <Modal
          v-model="exportModal"
          :closable="false"
          :width=600
          title="自定义导出">
          <p slot="header" style="color:#f60;text-align:left">
            <Icon type="ios-information-circle"></Icon>
            <span>按所选二级类型导出选中类型下的所有记录</span>
          </p>
          <Form ref="exportForm" :model="exportForm" :label-width="85">
            <!-- <FormItem label="资产类型" prop="asset_type">
              <Select v-model="exportForm.asset_type" @on-change="exportTypeChange" clearable>
                <Option v-for="item in allTypeData" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem> -->
              <Alert type="success" show-icon>
                <CheckboxGroup v-model="exportForm.asset_type_parent" @on-change="parentTypeChange">
                    <Checkbox  v-for="item in allTypeDataParent" :label="item.id" :key="item.id">{{ item.name }}</Checkbox>
                </CheckboxGroup>
                 <template slot="desc">
                     <span style="color:red">选中后会自动带出所有 物资二级类型，可自行增减二级类型进行导出</span>
                </template>
              </Alert>
             <!-- <FormItem label="物资类型" prop="asset_type_parent">
                <Select v-model="exportForm.asset_type_parent" clearable multiple>
                  <Option v-for="item in allTypeDataParent" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem> -->
              <FormItem label="物资二级类型" prop="asset_type">
                <Select v-model="exportForm.asset_type" clearable multiple @on-change="sonTypeChange">
                  <Option v-for="item in allTypeDataSonExport" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
            <!-- <FormItem label="选中所有字段">
              <Checkbox v-model="exportForm.single" @on-change="ckChange">选中所有字段</Checkbox>
            </FormItem> -->
            <!-- <FormItem label="导出字段" prop="columns">
              <Select v-model="exportForm.columns" placeholder="请选择导出字段" multiple>
                <Option v-for="item in tableColumnsSel" :key="item" :value="item" :label="item"></Option>
              </Select>
            </FormItem> -->
          </Form>
          <div slot="footer">
            <Button type="primary" @click="exportCustomData" :loading="exportCustomLoading">确认</Button>
            <Button  @click="cancelModal" >取消</Button>
          </div>
        </Modal>
        <Modal
          v-model="importModal"
          :closable="false"
          title="按下面格式要求导入excel文件">
          <Card :bordered="false">
            <p slot="title" style="color:#f60;text-align:left">导入格式（必须按顺序写入到xls文件，第一行的标题如下）：</p>
            <p><b>资产：</b> 资产编号、资产类型、资产状态、采购日期、供应商、使用人、领用时间、所属公司、备注、其他（其他信息写在后面）</p><br>
            <p><b>出入记录：</b> 经手人、资产编号、类型、操作人、操作时间、备注</p><br>
            <p><b>注意：</b>资产状态只能有4种：“在库”、“借出”、“维修”、“报废”。 不是这4种状态默认转换为“在库”】</p><br>
            <p>每次最多只能导入10000条数据</p><br>
            <p><b>日期格式：</b>yyyy-m-d</p><br>
            <p><b>时间格式：</b>yyyy-m-d h:mm:ss</p>
          </Card>
          <div slot="footer" style="text-align: center">
            <Upload :action="assetUploadFileUrl" :before-upload="handleBeforeUpload" :data="importParams"
            :show-upload-list="false" accept=".xls, .xlsx" :max-size="10240"
            :on-exceeded-size="maxSize" :on-success="handleFileSuccess" :on-error="handleFileError" style="display: inline-block;margin-right: 10px;">
              <Button
  type="primary"
 icon="ios-cloud-upload-outline" :loading="uploadLoading">导入资产</Button>
            </Upload>
            <Upload :action="assetFlowUploadFileUrl" :before-upload="handleBeforeUpload" :data="importParams"
            :show-upload-list="false" accept=".xls, .xlsx" :max-size="10240"
            :on-exceeded-size="maxSize" :on-success="handleFileSuccess" :on-error="handleFileError" style="display: inline-block;">
              <Button type="primary" icon="ios-cloud-upload-outline" :loading="uploadLoading">导入资产出入库记录</Button>
            </Upload>
            <!-- <Button type="primary" @click="importData">确认</Button>
            <Button  @click="cancelModal" >取消</Button> -->
          </div>
        </Modal>
        <Drawer
          :title="changeModalTitle"
          v-model="changeModal"
          width="550"
          :mask-closable="true"
          @on-close="changeModalCancel">
          <div>
            <Form ref="changeForm" :model="changeForm" :label-width="100" :rules="changeRule">
              <FormItem label="资产编号" prop="asset_id">
                <Input v-model="changeForm.asset_id" />
              </FormItem>
              <FormItem label="资产类型" prop="asset_type_parent">
                <Select v-model="changeForm.asset_type_parent" @on-change="assetTypeParentChange" clearable>
                  <Option v-for="item in allTypeDataParent" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
              <FormItem label="资产二级分类" prop="asset_type">
                <Select v-model="changeForm.asset_type" @on-change="assetTypeChange" clearable>
                  <Option v-for="item in allTypeDataSon" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
              <FormItem label="状态" prop="status">
                <Select v-model="changeForm.status">
                  <Option v-for="item in allStatusData" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
              <!-- <FormItem label="供应商" prop="supplier">
                <Select v-model="changeForm.supplier">
                  <Option v-for="item in allSupplierData" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem> -->
              <FormItem label="采购日期" prop="buyTimeFormat">
                <DatePicker v-model="buyTimeFormat" @on-change="buyTimeChange" :options="options3" type="date" style="width:100%;"></DatePicker>
              </FormItem>

              <FormItem label="保管人">
                <!-- <Input v-model="changeForm.use_person" disabled/> -->
                <RadioGroup v-model="tabPeopleValue" type="button" @on-change="switchChange">
                  <Radio label="name1">人员模糊查找</Radio>
                  <Radio label="name2">组织架构选择</Radio>
                </RadioGroup>
                    <Treeselect ref="tree1" v-if="tree1" :async="true" v-model="changeForm.use_person_obj" valueConsistsOf='LEAF_PRIORITY' @input="eventInput" valueFormat="object" clearable
                      :multiple="false" :options="options" :load-options="loadOptionsAsync" :searchable="true" :disableBranchNodes="true" placeholder="人员模糊查找">
                      <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
                        <img v-if="node.raw.avatar" width="10" height="10" :src="node.raw.avatar">{{ node.label }}
                      </label>
                      </Treeselect>
                   <Treeselect ref="tree2" v-if="tree2" :async="false" v-model="changeForm.use_person_obj" valueConsistsOf='LEAF_PRIORITY' @input="eventInput" valueFormat="object" clearable
                        :multiple="false" :options="options" :load-options="loadOptions" :searchable="true" :disableBranchNodes="true" placeholder="组织架构选择">
                        <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
                          <img v-if="node.raw.avatar" width="10" height="10" :src="node.raw.avatar">{{ node.label }}
                        </label>
                  </Treeselect>
              </FormItem>
              <FormItem label="保管人部门">
                <Input v-model="changeForm.use_person_department" disabled/>
              </FormItem>
              <FormItem label="领用时间" prop="use_time">
                <DatePicker v-model="changeForm.use_time" type="date" :editable="false" style="width:100%;" :options="options3" :time-picker-options="options4" format="yyyy-MM-dd" @on-change="handleChange" placeholder="请选择领用时间"></DatePicker>
              </FormItem>
              <!-- <FormItem label="关联资产" prop="bind_asset">
                <Input v-model="changeForm.bind_asset" />
              </FormItem> -->
              <FormItem label="备注" prop="remark">
                <Input v-model="changeForm.remark" type="textarea" />
              </FormItem>
              <FormItem
                v-for="(item, index) in formDynamic"
                v-if="item.status && !item.delete"
                :key="index"
                :label-width="10"
                :prop="'items.' + index + '.value'">
                <Row>
                  <Col span="3">
                    <Input type="text" v-model="item.key" placeholder="Key" :disabled="!item.delete" />
                  </Col>
                  <Col span="14" offset="1">
                    <Input type="text" v-model="item.value" placeholder="Value" />
                  </Col>
                </Row>
              </FormItem>
              <FormItem
                v-for="(item, index) in formDynamic"
                v-if="item.status && item.delete"
                :key="index"
                :label-width="10"
                :prop="'items.' + index + '.value'">
                <Row>
                  <Col span="3">
                    <Input type="text" v-model="item.key" placeholder="Key" />
                  </Col>
                  <Col span="14" offset="1">
                    <Input type="text" v-model="item.value" placeholder="Value" />
                  </Col>
                  <Col span="4" offset="1">
                    <Button type="error" @click="formRemove(index)">移除字段</Button>
                  </Col>
                </Row>
              </FormItem>
              <FormItem>
                <Row>
                  <Col span="12">
                    <Button type="dashed" long @click="formAdd" icon="md-add">添加字段</Button>
                  </Col>
                </Row>
              </FormItem>
              <FormItem>
                <Button type="primary" @click="changeSubmit" :loading="assetChangeLoading">提交</Button>
                <Button style="margin-left: 8px" @click="changeModal = false">取消</Button>
              </FormItem>
            </Form>
          </div>
        </Drawer>
        <Card shoaw>
          <Row>
            <Col>
              <Form :model="searchForm" ref="searchForm" inline :label-width="120" label-position="right">
                <FormItem label="资产编号">
                  <Input v-model="searchForm.asset_id" style="min-width: 200px" />
                </FormItem>
                <FormItem label="物资申购单编号">
                  <Input v-model="searchForm.purchase_order" style="min-width: 200px" />
                </FormItem>
                <!-- <FormItem label="资产类型">
                  <Select v-model="searchForm.asset_type" style="min-width:200px" clearable>
                    <Option v-for="item in allTypeData" :value="item.id" :key="item.id">{{ item.name }}</Option>
                  </Select>
                </FormItem> -->
               <FormItem label="资产类型" prop="asset_type_parent">
                <Select v-model="searchForm.asset_type_parent" multiple @on-change="assetTypeParentChange" clearable>
                  <Option v-for="item in allTypeDataParent" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
              <FormItem label="物资二级分类" prop="asset_type">
                <Select v-model="searchForm.asset_type" multiple clearable>
                  <Option v-for="item in allTypeDataSon" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
                <FormItem label="供应商">
                  <Select v-model="searchForm.supplier" style="min-width:200px" clearable>
                    <Option v-for="item in allSupplierData" :value="item.id" :key="item.id">{{ item.name }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="资产状态">
                  <Select v-model="searchForm.status__in" multiple style="min-width:200px" clearable>
                    <Option v-for="item in allStatusData" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="操作人">
                  <Select v-model="searchForm.operator" style="min-width:200px" clearable>
                    <Option v-for="item in allUserData" :value="item.id" :key="item.id">{{ item.name }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="保管人">
                  <Input v-model="searchForm.use_person" style="min-width: 200px" />
                </FormItem>
                <FormItem label="物资名称(更多信息)">
                  <Input v-model="searchForm.asset_info" style="min-width: 200px" />
                </FormItem>
                <FormItem :label-width="0" class="mob-align-right">
                  <Button type="primary" @click="getAssetsData()">搜索</Button>
                  <Button style="margin-left: 8px" @click="searchReset">重置</Button>
                <Button style="margin-left:5px;" type="info" @click="showColConfig">表头重置</Button>
                </FormItem>
              </Form>
            </Col>
          </Row>
          <Row>
            <Col>
              <div :style="{float: 'right'}">
                <Button type="info" :style="{marginRight: '10px',marginBottom: '10px'}" @click="addAsset">添加</Button>
                <Button type="info" :style="{marginRight: '10px',marginBottom: '10px'}" @click="ModifyOpen">修改</Button>
                <Button type="success" :style="{marginRight: '10px',marginBottom: '10px'}" @click="lendModalOpen">借出</Button>
                <Button type="success" :style="{marginRight: '10px',marginBottom: '10px'}" @click="returnModalOpen">归还</Button>
                <Button type="warning" :style="{marginRight: '10px',marginBottom: '10px'}" @click="maintainModalOpen">维修</Button>
                <Button type="warning" :style="{marginRight: '10px',marginBottom: '10px'}" @click="scrapModalOpen">报废</Button>
                <Button type="error" :style="{marginRight: '10px',marginBottom: '10px'}"  @click="Delete">删除</Button>
                <Button type="primary" :style="{marginRight: '10px',marginBottom: '10px'}" @click="importModal=true">导入</Button>
                <Button type="primary" :style="{marginRight: '10px',marginBottom: '10px'}" @click="exportCurrentData">导出当前</Button>
                <Poptip
                    confirm
                    title="确定要导出所有资产吗？"
                    @on-ok="exportAllData">
                    <Button type="primary" :style="{marginRight: '10px',marginBottom: '10px'}">导出所有</Button>
                </Poptip>
                <Button type="primary" :style="{marginRight: '10px',marginBottom: '10px'}" @click="exportModal=true">自定义导出</Button>
              </div>
            </Col>
          </Row>
          <Table
            border
            ref="tableData"
            :loading="TableLoading"
            :data="asset.data"
            :columns="asset.col"
            size="small">
          </Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: right;">
              <page
                :total="asset.count"
                :current="asset.page"
                :page-size="asset.size"
                show-sizer
                @on-page-size-change="getAssetsDataSize"
                @on-change="getAssetsData"></page>
            </div>
          </div>
        </Card>
        <Drawer title="修改记录" :closable="false" width="640" v-model="LogsModel">
          <Logs :logs="RevisionLogs" />
        </Drawer>
      </TabPane>
      <TabPane label="资产类型管理" name="assetsTypeTab">
        <Drawer
          :title="typeChangeModalTitle"
          v-model="typeChangeModal"
          width="500"
          :mask-closable="true"
          @on-close="typeChangeModalCancel">
          <div>
            <Form ref="typeChangeForm" :model="typeChangeForm" :label-width="90" :rules="typeChangeRule">
              <FormItem label="类型名称" prop="name">
                <Input v-model="typeChangeForm.name" />
              </FormItem>
              <FormItem label="定制资产字段" prop="customize_asset_field">
                <Input v-model="typeChangeForm.customize_asset_field" />
              </FormItem>
              <FormItem>
                <Button type="primary" @click="typeChangeSubmit">提交</Button>
                <Button style="margin-left: 8px" @click="typeChangeModal = false">取消</Button>
              </FormItem>
            </Form>
          </div>
        </Drawer>
        <Card>
          <Row>
            <Col>
              <Button
                style="float: right;"
                @click="typeChangeModal = true; typeChangeModalTitle = '添加资产类型'"
                type="primary"
                :style="{marginBottom: '10px'}"
                icon="md-add">添加资产</Button>
            </Col>
          </Row>
          <Table
            border
            :loading="typeTableLoading"
            :data="type.data"
            :columns="type.columns">
          </Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: right;">
              <page
                :total="type.count"
                :current="type.page"
                :page-size="type.size"
                @on-change="getAssetTypeData"></page>
            </div>
          </div>
        </Card>
      </TabPane>
      <TabPane label="供应商管理" name="supplierTab">
        <Drawer
          :title="supplierChangeModalTitle"
          v-model="supplierChangeModal"
          width="500"
          :mask-closable="true"
          @on-close="supplierChangeModalCancel">
          <div>
            <Form ref="supplierChangeForm" :model="supplierChangeForm" :label-width="90" :rules="supplierChangeRule">
              <FormItem label="供应商名称" prop="name">
                <Input v-model="supplierChangeForm.name" />
              </FormItem>
              <FormItem label="联系人" prop="contact">
                <Input v-model="supplierChangeForm.contact" />
              </FormItem>
              <FormItem label="固定电话" prop="fixed_telephone">
                <Input v-model="supplierChangeForm.fixed_telephone" />
              </FormItem>
              <FormItem label="手机号码" prop="mobile_phone">
                <Input v-model="supplierChangeForm.mobile_phone" />
              </FormItem>
              <FormItem label="地址" prop="address">
                <Input v-model="supplierChangeForm.address" />
              </FormItem>
              <FormItem label="邮箱" prop="email">
                <Input v-model="supplierChangeForm.email" />
              </FormItem>
              <FormItem label="QQ" prop="qq">
                <Input v-model="supplierChangeForm.qq" />
              </FormItem>
              <FormItem label="备注" prop="remark">
                <Input v-model="supplierChangeForm.remark" type="textarea" />
              </FormItem>
              <FormItem>
                <Button type="primary" @click="supplierChangeSubmit">提交</Button>
                <Button style="margin-left: 8px" @click="supplierChangeModal = false">取消</Button>
              </FormItem>
            </Form>
          </div>
        </Drawer>
        <Card>
          <Row>
            <Col>
              <Button
                style="float: right;"
                @click="supplierChangeModal = true; supplierChangeModalTitle = '添加供应商'"
                type="primary"
                :style="{marginBottom: '10px'}"
                icon="md-add">添加供应商</Button>
            </Col>
          </Row>
          <Table
            border
            :loading="supplierTableLoading"
            :data="supplier.data"
            :columns="supplier.columns">
          </Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: right;">
              <page
                :total="supplier.count"
                :current="supplier.page"
                :page-size="supplier.size"
                @on-change="getSupplierData"></page>
            </div>
          </div>
        </Card>
      </TabPane>
      <TabPane label="库存统计" name="assetsCountsTab">
        <Card>
          <Table
            border
            :loading="assetsCountTableLoading"
            :data="assetsCount.data"
            :columns="assetsCount.columns">
          </Table>
        </Card>
      </TabPane>
      <TabPane label="出入库记录" name="assetsFlowsTab">
        <Card shoaw>
          <Row>
            <Col>
              <Form :model="flowSearchForm" ref="flowSearchForm" inline :label-width="75" label-position="right">
                <FormItem label="资产编号">
                  <Input v-model="flowSearchForm.asset__asset_id" style="min-width: 200px" />
                </FormItem>
                <FormItem label="流动类型">
                  <Select v-model="flowSearchForm.type" style="min-width:200px" clearable>
                    <Option v-for="item in flowTypeData" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="资产类型">
                  <Select v-model="flowSearchForm.asset__asset_type" style="min-width:200px" clearable>
                    <Option v-for="item in allTypeData" :value="item.id" :key="item.id">{{ item.name }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="供应商">
                  <Select v-model="flowSearchForm.asset__supplier" style="min-width:200px" clearable>
                    <Option v-for="item in allSupplierData" :value="item.id" :key="item.id">{{ item.name }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="资产状态">
                  <Select v-model="flowSearchForm.asset__status" style="min-width:200px" clearable>
                    <Option v-for="item in allStatusData" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="操作人">
                  <Select v-model="flowSearchForm.operator" style="min-width:200px" clearable>
                    <Option v-for="item in allUserData" :value="item.id" :key="item.id">{{ item.name }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="保管人">
                  <Input v-model="flowSearchForm.hand_person" style="min-width: 200px" />
                </FormItem>
                <FormItem label="更多信息">
                  <Input v-model="flowSearchForm.asset__asset_info" style="min-width: 200px" />
                </FormItem>
                <FormItem :label-width="0" class="mob-align-right">
                  <Button type="primary" @click="getAssetsFlowData()">搜索</Button>
                  <Button style="margin-left: 8px" @click="flowSearchReset">重置</Button>
                </FormItem>
              </Form>
            </Col>
          </Row>
          <Table
            border
            size="small"
            :loading="flowTableLoading"
            :data="flow.data"
            :columns="flow.columns">
          </Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: right;">
              <page
                :total="flow.count"
                :current="flow.page"
                :page-size="flow.size"
                @on-change="getAssetsFlowData"></page>
            </div>
          </div>
        </Card>
      </TabPane>
       <TabPane label="资产盘点" name="inventory">
        <Modal
          v-model="modalInventory"
          width="1650"
          scrollable
          :title="modalInventoryTitle">
          <InventoryList  ref="InventoryList" :id="inventoryId" />
           <div slot="footer">
           </div>
        </Modal>
        <Drawer
          :title="inventoryChangeModalTitle"
          v-model="inventoryChangeModal"
          width="500"
          :mask-closable="true"
          @on-close="inventoryChangeModalCancel">
          <div>
            <Form ref="inventoryChangeForm" :model="inventoryChangeForm" :label-width="100" :rules="inventoryChangeRule">
              <FormItem label="盘点设备类别" prop="inventory_asset_type">
                 <Select v-model="inventoryChangeForm.inventory_asset_type" filterable multiple>
                  <Option v-for="item in allTypeData" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
              <FormItem label="盘点人" prop="counting_people_obj">
                <!-- <Input v-model="inventoryChangeForm.counting_people" /> -->
                <Treeselect  v-model="inventoryChangeForm.counting_people_obj" valueConsistsOf='LEAF_PRIORITY' @input="eventInput" valueFormat="object"
                 :multiple="true" :options="options"  :load-options="loadOptions" :searchable="false" :disableBranchNodes="true" placeholder="选择盘点人">
                <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
                  <img v-if="node.raw.avatar" width="10" height="10" :src="node.raw.avatar">{{ node.label }}
                </label>
                </Treeselect>
              </FormItem>
              <FormItem label="允许自行盘点" prop="is_self_inventory">
                <RadioGroup v-model="inventoryChangeForm.is_self_inventory">
                  <Radio :label="1">是</Radio>
                  <Radio :label="0">否</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="盘点说明" prop="explain">
                <Input v-model="inventoryChangeForm.explain" type="textarea" />
              </FormItem>
              <FormItem>
                <Button type="primary" @click="inventoryChangeSubmit">确认</Button>
                <Button style="margin-left: 8px" @click="inventoryChangeModal = false">取消</Button>
              </FormItem>
            </Form>
          </div>
        </Drawer>
        <Card>
          <Row>
            <Col>
             <div style="float: right">
              <Button
                style="margin-bottom: 10px; margin-right:5px;"
                @click="addInventory"
                type="primary">发起盘点</Button>
              </div>
            </Col>
          </Row>
          <Table
            border
            :loading="inventoryTableLoading"
            :data="inventory.data"
            :columns="inventory.columns">
          </Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: right;">
              <page
                :total="inventory.count"
                :current="inventory.page"
                :page-size="inventory.size"
                @on-change="getInventoryData"></page>
            </div>
          </div>
        </Card>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { GetALLUsers } from '@/api/user'
import * as cmdbRequestApi from '@/api/cmdb'
import expandRow from './table-expand.vue'
import InventoryList from './InventoryList.vue'
import Logs from './Logs'
import excel from '@/libs/excel'
import moment from 'moment'
import { Treeselect, LOAD_CHILDREN_OPTIONS, ASYNC_SEARCH } from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'fixed-asset',
  components: { expandRow, 'Logs': Logs, InventoryList, Treeselect, draggable },
  data () {
    return {
      tabPeopleValue: 'name1',
      tree2: false,
      tree1: true,
      loadOption: null,
      tableColModal: false,
      saveShowColConfiging: false,
      assetChangeLoading: false,
      options3: {
        disabledDate (date) {
          return date && date.valueOf() < Date.now() - 86400000
        }
      },
      options4: {
        'disabled-hours': this.getTimeArray(new Date().getHours()),
        'disabled-minutes': this.getTimeArray(new Date().getMinutes())
      },
      options: [],
      importParams: {
        userId: this.$store.state.user.userId
      },
      uploadLoading: false,
      assetUploadFileUrl: cmdbRequestApi.assetUploadFileUrl,
      assetFlowUploadFileUrl: cmdbRequestApi.assetFlowUploadFileUrl,
      importModal: false,
      exportModal: false,
      exportForm: {
        asset_type_parent: [],
        asset_type: [],
        single: false,
        columns: []
      },
      ruleValidate: {
        asset_type_parent: [
          { required: true, message: '请选择导出资产类型 !', trigger: 'change', type: 'number' }
        ],
        columns: [
          { required: true, message: '请选择导出字段 !', trigger: 'change', type: 'array' }
        ]
      },
      tableColumns: ['资产编码', '资产类型', '关联资产', '所属公司', '采购日期', '供应商', '保管人', '领用时间', '资产状态', '备注'],
      tableColumnsSel: [],
      exportCustomLoading: false,
      modalInventoryTitle: '',
      modalInventory: false,
      inventoryId: null,
      tabValue: 'assetsTab',
      RevisionLogs: [],
      changeModal: false,
      TableLoading: false,
      changeModalTitle: '添加资产',
      changeForm: {
        id: 0,
        asset_id: '',
        asset_type_parent: '',
        asset_type: '',
        status: 1,
        supplier: '',
        buy_time: '',
        remark: '',
        use_person: '',
        use_person_obj: null,
        use_person_department: '',
        use_time: null,
        switch: true
      },
      buyTimeFormat: '',
      changeRule: {
        asset_id: { required: true, message: '资产编号不能为空', trigger: 'blur' },
        asset_type_parent: { required: true, message: '请选择资产类型', type: 'number', trigger: 'change' },
        asset_type: { required: true, message: '请选择资产二级分类', type: 'number', trigger: 'change' }
      },
      allStatusData: [
        { 'value': 1, 'label': '在库' },
        { 'value': 2, 'label': '借出' },
        { 'value': 3, 'label': '维修' },
        { 'value': 4, 'label': '报废' }
      ],
      allTypeData: [],
      allTypeDataParent: [],
      allTypeDataSon: [],
      allTypeDataSonExport: [],
      allSupplierData: [],
      asset: {
        data: [],
        orderColumnData: [],
        orderColumn: [
          {
            title: '选中',
            align: 'center',
            minWidth: 30,
            key: '',
            render: (h, params) => {
              return h('div', [
                h('Checkbox', {
                  props: {
                    value: params.row.checkBox
                  },
                  on: {
                    'on-change': (e) => {
                      this.asset.orderColumnData[params.index].checkBox = e
                    }
                  }
                })
              ])
            }
          },
          {
            title: '列名',
            minWidth: 150,
            align: 'left',
            key: 'title'
          }
          // {
          //   title: '列名(key)',
          //   minWidth: 150,
          //   align: 'center',
          //   key: 'key'
          // }
        ],
        col: [],
        tableColumns: [],
        tableColumnsNo: [],
        columns: {
          expand: {
            type: 'expand',
            title: '更多',
            align: 'center',
            key: 'expand',
            minWidth: 60,
            render: (h, params) => {
              return h('div', [
                h(expandRow, {
                  props: {
                    row: params.row.asset_info_dict
                  }
                })
              ])
            }
          },
          selection: {
            title: '选中',
            align: 'center',
            minWidth: 70,
            key: '',
            render: (h, params) => {
              return h('div', [
                h('Checkbox', {
                  props: {
                    value: params.row.checkBox
                  },
                  on: {
                    'on-change': (e) => {
                      this.asset.data.forEach((items) => {
                        this.$set(items, 'checkBox', false)
                        this.selectRow = ''
                      })
                      this.asset.data[params.index].checkBox = e
                      if (e) {
                        this.selectRow = params.row
                      }
                    }
                  }
                })
              ])
            }
          },
          purchase_order: {
            title: '物资申购单编号',
            minWidth: 150,
            align: 'center',
            key: 'purchase_order'
          },
          asset_parent_type: {
            title: '资产类型',
            minWidth: 100,
            align: 'center',
            key: 'asset_parent_type',
            render: (h, params) => {
              if (params.row.asset_type) {
                return h('span', params.row.asset_type.parent.name)
              }
            }
          },
          asset_type: {
            title: '物资二级分类',
            minWidth: 120,
            align: 'center',
            key: 'asset_type',
            render: (h, params) => {
              if (params.row.asset_type) {
                return h('span', params.row.asset_type.name)
              }
            }
          },
          asset_info_name: {
            title: '物资名称',
            align: 'center',
            key: 'asset_info_name',
            minWidth: 100,
            render: (h, params) => {
              return h('span', params.row.asset_info_dict['名称'])
            }
          },
          asset_info_gg: {
            title: '规格',
            minWidth: 100,
            key: 'asset_info_gg',
            align: 'center',
            render: (h, params) => {
              return h('span', params.row.asset_info_dict['规格'])
            }
          },
          asset_info_xh: {
            title: '型号',
            minWidth: 100,
            key: 'asset_info_xh',
            align: 'center',
            render: (h, params) => {
              return h('span', params.row.asset_info_dict['型号'])
            }
          },
          asset_info_jz: {
            title: '价值',
            minWidth: 80,
            align: 'center',
            key: 'asset_info_jz',
            render: (h, params) => {
              return h('span', params.row.asset_info_dict['价值'])
            }
          },
          buy_time: {
            title: '采购日期',
            minWidth: 130,
            align: 'center',
            key: 'buy_time'
          },
          asset_id: {
            title: '资产编号',
            minWidth: 100,
            align: 'center',
            key: 'asset_id'
          },
          asset_info_sn: {
            title: 'SN',
            align: 'center',
            minWidth: 90,
            key: 'asset_info_sn',
            render: (h, params) => {
              return h('span', params.row.asset_info_dict['SN'])
            }
          },
          asset_info_wz: {
            title: '位置',
            align: 'center',
            minWidth: 90,
            key: 'asset_info_wz',
            render: (h, params) => {
              return h('span', params.row.asset_info_dict['位置'])
            }
          },
          // {
          //   title: '固资管理人',
          //   align: 'center',
          //   minWidth: 90,
          //   render: (h, params) => {
          //     return h('span', params.row.asset_info_dict['固资管理人'] ? params.row.asset_info_dict['固资管理人'] : params.row.asset_info_dict['保管人'])
          //   }
          // },
          status: {
            title: '状态',
            minWidth: 80,
            align: 'center',
            key: 'status',
            render: (h, params) => {
              let statusTran = {
                1: '在库',
                2: '借出',
                3: '维修',
                4: '报废'
              }
              if (params.row.status) {
                return h('span', statusTran[params.row.status])
              }
            }
          },
          use_person: {
            title: '保管人',
            minWidth: 100,
            align: 'center',
            key: 'use_person'
          },
          use_person_department: {
            title: '保管人部门',
            minWidth: 100,
            align: 'center',
            key: 'use_person_department'
          },
          use_time: {
            title: '领用时间',
            minWidth: 180,
            align: 'center',
            key: 'use_time',
            render: (h, params) => {
              if (params.row.use_time) {
                return h('div', moment(params.row.use_time).format('YYYY-MM-DD'))
              } else {
                return null
              }
            }
          },
          // {
          //   title: '关联资产',
          //   minWidth: 100,
          //   align: 'center',
          //   key: 'bind_asset'
          // },
          operator_full_name: {
            title: '操作人',
            minWidth: 100,
            align: 'center',
            key: 'operator_full_name'
          },
          operate_time: {
            title: '操作时间',
            minWidth: 180,
            align: 'center',
            key: 'operate_time',
            render: (h, params) => {
              if (params.row.operate_time) {
                return h('div', moment(params.row.operate_time).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          // {
          //   title: '供应商',
          //   key: 'supplier',
          //   minWidth: 100,
          //   align: 'center',
          //   render: (h, params) => {
          //     if (params.row.supplier) {
          //       return h('span', params.row.supplier.name)
          //     }
          //   }
          // },
          // {
          //   title: '公司',
          //   align: 'center',
          //   minWidth: 180,
          //   key: 'tenant_name'
          // },
          // {
          //   title: '备注',
          //   align: 'center',
          //   minWidth: 100,
          //   tooltip: true,
          //   key: 'remark'
          // },
          action: {
            title: '查看',
            minWidth: 200,
            align: 'center',
            key: '',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    color: '#2B85E4',
                    'border-right': '1px solid #e8e8e8',
                    'border-radius': '0'
                  },
                  props: {
                    type: 'text',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.flowSearchForm.asset__asset_id = params.row.asset_id
                      this.getAssetsFlowData()
                      this.tabValue = 'assetsFlowsTab'
                    }
                  }
                }, '出入库记录'),
                h('Button', {
                  style: {
                    color: '#2B85E4'
                  },
                  props: {
                    type: 'text',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.revisionLog(params.row.id)
                      this.LogsModel = true
                    }
                  }
                }, '修改记录')
              ])
            }
          }
        },
        count: 1,
        page: 1,
        size: 15
      },
      LogsModel: false,
      selectRow: '',
      formDynamicIndex: 1,
      formDynamic: [],

      allUserData: [],
      searchForm: {
        server_id: '',
        purchase_order: '',
        asset_type: '',
        asset_type_parent: [],
        supplier: '',
        status__in: [1, 2, 3],
        operator: '',
        use_person: '',
        asset_info: ''
      },

      typeChangeModal: false,
      typeTableLoading: false,
      typeChangeModalTitle: '添加资产类型',
      type: {
        data: [],
        columns: [
          {
            title: '类型ID',
            minWidth: 100,
            align: 'center',
            key: 'id'
          },
          {
            title: '类型名称',
            minWidth: 200,
            align: 'center',
            key: 'name'
          },
          {
            title: '自定义资产字段',
            align: 'center',
            minWidth: 200,
            key: 'customize_asset_field'
          },

          {
            title: '操作',
            align: 'center',
            minWidth: 150,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.typeModifyOpen(params.row)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.typeDelete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 1,
        page: 1,
        size: 10
      },
      typeChangeForm: {
        id: 0,
        name: '',
        customize_asset_field: ''
      },
      typeChangeRule: {
        name: { required: true, message: '类型名称不能为空', trigger: 'blur' }
      },

      supplierChangeModal: false,
      supplierTableLoading: false,
      supplierChangeModalTitle: '添加供应商',
      supplier: {
        data: [],
        columns: [
          {
            title: '供应商ID',
            minWidth: 100,
            align: 'center',
            key: 'id'
          },
          {
            title: '供应商名称',
            align: 'center',
            minWidth: 100,
            key: 'name'
          },
          {
            title: '联系人',
            align: 'center',
            minWidth: 100,
            key: 'contact'
          },
          {
            title: '固定电话',
            align: 'center',
            minWidth: 100,
            key: 'fixed_telephone'
          },
          {
            title: '手机号码',
            align: 'center',
            minWidth: 100,
            key: 'mobile_phone'
          },
          {
            title: '地址',
            align: 'center',
            minWidth: 100,
            key: 'address'
          },
          {
            title: '邮箱',
            align: 'center',
            minWidth: 100,
            key: 'email'
          },
          {
            title: 'QQ',
            align: 'center',
            minWidth: 100,
            key: 'qq'
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 150,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.supplierModifyOpen(params.row)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.supplierDelete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 1,
        page: 1,
        size: 10
      },
      supplierChangeForm: {
        id: 0,
        name: '',
        contact: '',
        fixed_telephone: '',
        mobile_phone: '',
        address: '',
        email: '',
        qq: '',
        remark: ''
      },
      supplierChangeRule: {
        name: { required: true, message: '供应商名称不能为空', trigger: 'blur' }
      },
      inventoryChangeModal: false,
      inventoryTableLoading: false,
      inventoryChangeModalTitle: '发起盘点',
      inventory: {
        data: [],
        columns: [
          {
            title: 'ID',
            minWidth: 100,
            align: 'center',
            key: 'id'
          },
          {
            title: '开始时间',
            align: 'center',
            minWidth: 100,
            key: 'start_time'
          },
          {
            title: '结束时间',
            align: 'center',
            minWidth: 100,
            key: 'end_time'
          },
          {
            title: '盘点资产类别',
            align: 'center',
            minWidth: 110,
            key: 'inventory_asset_type_list'
          },
          {
            title: '盘点人',
            align: 'center',
            minWidth: 100,
            key: 'counting_people'
          },
          {
            title: '允许自行盘点',
            key: 'is_self_inventory',
            align: 'center',
            minWidth: 150,
            render: (h, params) => {
              if (params.row.is_self_inventory) {
                return h('div', '允许')
              } else {
                return h('div', '不允许')
              }
            }
          },
          {
            title: '公司',
            align: 'center',
            minWidth: 100,
            key: 'company_name'
          },
          {
            title: '未盘数量',
            align: 'center',
            minWidth: 100,
            key: 'not_inventory_count'
          },
          {
            title: '需盘数量',
            align: 'center',
            minWidth: 100,
            key: 'inventory_count'
          },
          {
            title: '状态',
            align: 'center',
            minWidth: 100,
            key: 'status_txt'
          },
          {
            title: '盘点说明',
            align: 'center',
            minWidth: 100,
            key: 'explain'
          },
          {
            title: '盘点报表',
            align: 'center',
            minWidth: 250,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.inventoryId = params.row.id
                      this.modalInventoryTitle = params.row.start_time + '发起的盘点报表'
                      this.modalInventory = true
                    }
                  }
                }, '查看'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'left',
                    title: '你确定要结束盘点吗?'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    'on-ok': () => {
                      this.inventoryOver(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'warning',
                      size: 'small',
                      disabled: !(params.row.status === 1)
                    }
                  }, '结束盘点')
                ]),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'left',
                    title: '你确定要取消盘点吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.inventoryCancel(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small',
                      disabled: !(params.row.status === 1)
                    }
                  }, '取消盘点')
                ])
              ])
            }
          }
        ],
        count: 1,
        page: 1,
        size: 10
      },
      inventoryChangeForm: {
        inventory_asset_type: [],
        counting_people_obj: null,
        counting_people: null,
        counting_people_wechat_id: null,
        is_self_inventory: 0,
        explain: ''
      },
      inventoryChangeRule: {
        inventory_asset_type: { required: true, message: '类型不能为空 !', trigger: 'change', type: 'array' },
        counting_people_obj: { required: true, message: '盘点人不能为空 !', trigger: 'change', type: 'array' }
      },
      lendModal: false,
      lendForm: {
        asset_id: '',
        hand_person: '',
        remark: ''
      },
      lendRule: {
        asset_id: { required: true, message: '资产编号不能为空', trigger: 'blur' },
        hand_person: { required: true, message: '保管人不能为空', trigger: 'blur' }
      },

      returnModal: false,
      returnForm: {
        asset_id: '',
        hand_person: '',
        remark: '资产正常,可以入库！'
      },
      returnRule: {
        asset_id: { required: true, message: '资产编号不能为空', trigger: 'blur' },
        hand_person: { required: true, message: '归还人不能为空', trigger: 'blur' }
      },

      maintainModal: false,
      maintainForm: {
        asset_id: '',
        hand_person: '',
        remark: ''
      },
      maintainRule: {
        asset_id: { required: true, message: '资产编号不能为空', trigger: 'blur' },
        hand_person: { required: true, message: '维修方不能为空', trigger: 'blur' }
      },

      scrapModal: false,
      scrapForm: {
        asset_id: '',
        remark: ''
      },
      scrapRule: {
        asset_id: { required: true, message: '资产编号不能为空', trigger: 'blur' }
      },

      assetsCountTableLoading: false,
      assetsCount: {
        data: [],
        columns: [
          {
            title: '资产类型',
            key: 'type',
            align: 'center',
            minWidth: 90
          },
          {
            title: '在库数量',
            key: 'remainder',
            align: 'center',
            minWidth: 90
          },
          {
            title: '借出数量',
            key: 'lend',
            align: 'center',
            minWidth: 90
          },
          {
            title: '维修数量',
            key: 'maintain',
            align: 'center',
            minWidth: 90
          },
          {
            title: '报废数量',
            key: 'scrap',
            align: 'center',
            minWidth: 90
          },
          {
            title: '总',
            key: 'total',
            align: 'center',
            minWidth: 90
          }
        ]
      },

      flowTableLoading: false,
      flow: {
        data: [],
        columns: [
          {
            title: '保管人',
            key: 'hand_person',
            align: 'center',
            minWidth: 90
          },
          {
            title: '类型',
            key: 'type',
            align: 'center',
            minWidth: 90,
            render: (h, params) => {
              let typeTran = {
                1: '入库',
                2: '借出',
                3: '还回',
                4: '维修',
                5: '报废',
                6: '转移'
              }
              if (params.row.type) {
                return h('span', typeTran[params.row.type])
              }
            }
          },
          {
            title: '资产编号',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              if (params.row.asset) {
                return h('span', params.row.asset.asset_id)
              }
            }
          },
          {
            title: 'MAC地址',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              return h('span', params.row.asset.asset_info_dict['MAC'])
            }
          },
          {
            title: 'SN',
            align: 'center',
            minWidth: 90,
            render: (h, params) => {
              return h('span', params.row.asset.asset_info_dict['SN'])
            }
          },
          {
            title: '资产类型',
            align: 'center',
            minWidth: 90,
            render: (h, params) => {
              if (params.row.asset.asset_type) {
                return h('span', params.row.asset.asset_type.name)
              }
            }
          },
          {
            title: '操作人',
            align: 'center',
            minWidth: 90,
            key: 'operator_full_name'
          },
          {
            title: '操作时间',
            key: 'time',
            align: 'center',
            minWidth: 110,
            render: (h, params) => {
              if (params.row.time) {
                return h('div', moment(params.row.time).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '备注',
            key: 'remark',
            align: 'center',
            minWidth: 80
          }
        ],
        page: 1,
        count: 1,
        size: 13
      },
      flowSearchForm: {
        asset__asset_id: '',
        asset__asset_type: '',
        asset__supplier: '',
        asset__status: '',
        asset__asset_info: '',
        operator: '',
        hand_person: ''
      },
      flowTypeData: [
        { value: 1, label: '入库' },
        { value: 2, label: '借出' },
        { value: 3, label: '还回' },
        { value: 4, label: '维修' },
        { value: 5, label: '报废' }
      ]
    }
  },
  created: function () {
    this.getShowCol()
  },
  mounted: function () {
    this.getOrg(1)
    this.getAssetsData()
    this.getAllAssetType()
    this.getAllSupplier()
    this.getAssetTypeData()
    this.getUsers()
    this.getAssetsCountData()
    this.getAssetsFlowData()
    this.getSupplierData()
    this.getInventoryData()
    cmdbRequestApi.getContentTypeId({ 'model_name': 'Assets' }).then(res => {
      let result = res.data
      this.contentTypeId = result.content_type_id
    })
  },
  methods: {
    switchChange (name) {
      if (name === 'name1') {
        this.tree1 = true
        this.tree2 = false
      } else if (name === 'name2') {
        this.getOrg(1)
        this.tree1 = false
        this.tree2 = true
      }
    },
    handleSelectAll (status) {
      if (status) {
        this.asset.orderColumnData.forEach((items) => {
          this.$set(items, 'checkBox', true)
        })
      } else {
        this.asset.orderColumnData.forEach((items) => {
          this.$set(items, 'checkBox', false)
        })
      }
    },
    onDragDrop (first, end) {
      // 转成int型，方便后续使用
      first = parseInt(first)
      end = parseInt(end)
      let tmp = this.asset.orderColumnData[first]

      if (first < end) {
        for (var i = first + 1; i <= end; i++) {
          this.asset.orderColumnData.splice(i - 1, 1, this.asset.orderColumnData[i])
        }
        this.asset.orderColumnData.splice(end, 1, tmp)
      }

      if (first > end) {
        for (var j = first; j > end; j--) {
          this.asset.orderColumnData.splice(j, 1, this.asset.orderColumnData[j - 1])
        }
        this.asset.orderColumnData.splice(end, 1, tmp)
      }
      console.log(this.asset.orderColumnData)
    },
    showColConfig () {
      this.tableColModal = true
    },
    getShowCol () {
      cmdbRequestApi.getServerTableCol().then(res => {
        let result = res.data
        let keys = []
        let keysNo = []
        if (result.length) {
          for (let col in result) {
            let colName = Object.keys(result[col])[0]
            if (result[col][colName]) {
              keys.push(colName)
            } else {
              keysNo.push(colName)
            }
          }
        } else {
          for (let columnName in this.asset.columns) {
            if (columnName !== 'selection' && columnName !== 'action') {
              keys.push(columnName)
            }
          }
        }
        this.asset.tableColumns = keys
        this.asset.tableColumnsNo = keysNo
        this.getTableColumns()
      })
    },
    getTableColumns () {
      let orderData = []
      let data = [this.asset.columns.selection]
      this.asset.tableColumns.forEach(col => data.push(this.asset.columns[col]))
      data.push(this.asset.columns.action)
      this.asset.col = data
      // 初始化重置表头的 table 数据
      this.asset.tableColumns.forEach(col => {
        if (col !== 'selection' && col !== 'action') {
          orderData.push({ key: this.asset.columns[col].key, title: this.asset.columns[col].title, checkBox: true })
        }
      })
      this.asset.tableColumnsNo.forEach(col => {
        if (col !== 'selection' && col !== 'action') {
          orderData.push({ key: this.asset.columns[col].key, title: this.asset.columns[col].title, checkBox: false })
        }
      })
      this.asset.orderColumnData = orderData
    },
    saveShowColConfig () {
      console.log(this.asset.orderColumnData)
      this.saveShowColConfiging = true
      let reqData = {
        col: []
      }
      this.asset.orderColumnData.forEach(element => {
        if (element.checkBox) {
          reqData.col.push({ [element.key]: true })
        } else {
          reqData.col.push({ [element.key]: false })
        }
      })
      cmdbRequestApi.postServerTableCol(reqData).then(res => {
        this.$Notice.success({
          title: '保存成功'
        })
        this.tableColModal = false
        this.saveShowColConfiging = false
        this.getShowCol()
      }).catch(err0 => {
        this.saveShowColConfiging = false
        console.log(err0)
        if (err0.request) {
          this.$Notice.error({
            title: err0.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '保存失败'
          })
        }
      })
    },
    handleChange (date) {
      if (new Date(date).getHours() > new Date().getHours()) {
        this.options4['disabled-minutes'] = []
      } else {
        this.options4['disabled-minutes'] = this.getTimeArray(new Date().getMinutes())
      }
    },
    getTimeArray (num) {
      let array = []
      for (let i = 0; i < num; i++) {
        array.push(i)
      }
      return array
    },
    addInventory () {
      this.inventoryChangeModal = true
      this.inventoryChangeModalTitle = '发起盘点'
      this.inventoryChangeFormReset()
    },
    eventInput (value) {
      console.log(value)
      this.changeForm.use_person_department = value ? value.department : ''
    },
    getOrg (id) {
      let params = {
        parentid: id
      }
      cmdbRequestApi.getWxOrg(params).then(res => {
        if (id === 1) {
          this.options = res.data.result
        } else {
          return res.data.result
        }
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取公司组织列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取公司组织列表失败！服务器无响应'
          })
        }
      })
    },
    loadOptionsAsync ({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        // 异步搜索人员模式
        if (searchQuery) {
          let params = {
            parentid: 1,
            searchQuery: searchQuery,
            get_people: 1
          }
          cmdbRequestApi.getPeopleLst(params).then(res => {
            callback(null, res.data.result)
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '获取公司组织列表失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '获取公司组织列表失败！服务器无响应'
              })
            }
          })
        }
      }
    },
    loadOptions ({ action, parentNode, callback }) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        let params = {
          parentid: parentNode.id,
          get_people: 1
        }
        cmdbRequestApi.getWxOrg(params).then(res => {
          parentNode.children = res.data.result
          callback()
        }).catch(res => {
          if (res.request) {
            this.$Notice.error({
              title: '获取公司组织列表失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '获取公司组织列表失败！服务器无响应'
            })
          }
        })
      }
    },
    handleUploadFile () {
      this.uploadLoading = true
    },
    handleBeforeUpload (file) {
      const fileExt = file.name.split('.').pop().toLocaleLowerCase()
      if (fileExt === 'xlsx' || fileExt === 'xls') {
        this.uploadLoading = true
        return true
      } else {
        this.$Notice.warning({
          title: '文件类型错误',
          desc: '文件：' + file.name + '不是EXCEL文件，请选择后缀为.xlsx或者.xls的EXCEL文件。'
        })
      }
      return false
    },
    maxSize () {
      this.$Notice.warning({ title: '文件太大, 限制最大10M' })
    },
    handleFileSuccess (res, file) {
      this.uploadLoading = false
      this.importModal = false
      this.getAssetsData()
    },
    handleFileError (res, file) {
      this.uploadLoading = false
    },
    sonTypeChange (val) {
      let lst = JSON.parse(JSON.stringify(this.exportForm.asset_type_parent))
      for (let i in lst) {
        if (this.allTypeDataSonExport.filter(item => item.parent === lst[i]).map(m => m.id).filter(j => this.exportForm.asset_type.indexOf(j) > -1).length === 0) {
          this.exportForm.asset_type_parent = this.exportForm.asset_type_parent.filter(item => item !== lst[i])
        }
      }
    },
    parentTypeChange (val) {
      if (val.length > 0) {
        this.exportForm.asset_type = this.allTypeDataSonExport.filter(item => val.indexOf(item.parent) > -1).map(item => item.id)
      } else {
        this.exportForm.asset_type = []
      }
    },
    ckChange (val) {
      if (val) {
        this.exportForm.columns = this.tableColumnsSel
      } else {
        this.exportForm.columns = []
      }
    },
    cancelModal () {
      this.exportForm.single = false
      this.exportForm.columns = []
      this.exportForm.asset_type = []
      this.exportForm.asset_type_parent = []
      this.exportModal = false
    },
    formReset (name) {
      this.$refs[name].resetFields()
    },
    changeModalCancel () {
      this.changeFormReset()
      this.changeModal = false
    },
    changeFormReset () {
      this.getOrg(1)
      this.changeForm.id = 0
      this.changeForm.asset_id = ''
      this.changeForm.asset_type = ''
      this.changeForm.asset_type_parent = ''
      this.changeForm.use_person = ''
      this.changeForm.use_person_obj = null
      this.changeForm.use_person_department = ''
      this.changeForm.use_time = null
      // this.changeForm.bind_asset = ''
      this.changeForm.status = 1
      // this.changeForm.supplier = ''
      this.changeForm.buy_time = ''
      this.changeForm.remark = ''
      this.formDynamic = []
    },
    changeSubmit () {
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          let assetInfo = {}
          for (let i in this.formDynamic) {
            if (this.formDynamic[i].status === 1) {
              if (!this.formDynamic[i].key) {
                this.$Notice.error({ title: '请检查自定义字段, Key是必填的！' })
                return false
              }
              assetInfo[this.formDynamic[i].key] = this.formDynamic[i].value
            }
          }
          this.changeForm.asset_info = JSON.stringify(assetInfo)
          this.changeForm.use_time = this.changeForm.use_time ? this.changeForm.use_time : null
          this.changeForm.use_person = this.changeForm.use_person_obj && 'label' in this.changeForm.use_person_obj ? this.changeForm.use_person_obj.label : ''
          this.assetChangeLoading = true
          cmdbRequestApi.changeOpsCenterAssets(this.changeForm, this.changeForm.id).then(res => {
            if (res.data.code === 200) {
              this.$Notice.success({
                title: '操作成功！'
              })
              this.assetChangeLoading = false
              this.getAssetsData()
              this.changeFormReset()
              this.changeModal = false
            } else {
              this.$Message.error(res.data.msg)
            }
          }).catch(res => {
            this.assetChangeLoading = false
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    getAssetsDataSize (size) {
      this.asset.size = size
      this.getAssetsData(1)
    },
    getAssetsData (value = 1) {
      this.asset.page = value
      let params = JSON.parse(JSON.stringify(this.searchForm))
      params.size = this.asset.size
      params.page = this.asset.page
      params.asset_type = params.asset_type.length > 0 ? params.asset_type.join(',') : ''
      params.asset_type_parent = params.asset_type_parent.length > 0 ? params.asset_type_parent.join(',') : ''
      params['status__in'] = params['status__in'].join(',')
      this.TableLoading = true
      cmdbRequestApi.getOpsCenterAssets(params).then(res => {
        this.asset.data = res.data.results
        this.asset.count = res.data.count
        this.selectRow = ''
        this.TableLoading = false
      }).catch(res => {
        this.TableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取资产列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取资产列表失败！服务器无响应'
          })
        }
      })
    },
    addAsset () {
      this.changeModal = true
      this.tabPeopleValue = 'name1'
      this.tree1 = true
      this.tree2 = false
      this.changeModalTitle = '添加资产'
      this.changeFormReset()
    },
    ModifyOpen () {
      let row = this.selectRow
      if (row) {
        console.log(this.changeForm)
        setTimeout(function () {
          console.log('setTimeout')
        }, 3000)
        this.changeForm.id = row.id
        this.changeForm.asset_id = row.asset_id
        this.changeForm.bind_asset = row.bind_asset
        this.changeForm.status = row.status
        this.buyTimeFormat = row.buy_time
        this.changeForm.buy_time = row.buy_time
        this.changeForm.remark = row.remark
        this.changeForm.use_person = row.use_person
        this.changeForm.use_person_obj = row.use_person ? JSON.parse(JSON.stringify({ avatar: '', department: row.use_person_department, id: row.id, label: this.changeForm.use_person })) : null
        console.log(this.changeForm)
        this.changeForm.use_person_department = row.use_person_department
        this.changeForm.use_time = row.use_time ? moment(row.use_time).format('YYYY-MM-DD') : null
        let existForm = []
        if (row.asset_type) {
          this.changeForm.asset_type_parent = row.asset_type.parent.id
          this.allTypeDataSon = this.allTypeData.filter(item => item.parent === this.changeForm.asset_type_parent)
          this.changeForm.asset_type = row.asset_type.id
          try {
            let customizeForm = row.asset_type.customize_asset_field.split(',')
            for (let i in customizeForm) {
              this.formDynamicIndex++
              existForm.push(customizeForm[i])
              let value = ''
              try {
                value = row.asset_info_dict[customizeForm[i]]
              } catch (forErr) {
                value = ''
              }
              this.formDynamic.push({
                key: customizeForm[i],
                value: value,
                index: this.formDynamicIndex,
                status: 1,
                delete: false
              })
            }
          } catch (err) {}
        }
        if (row.asset_info_dict instanceof Object) {
          for (let v in row.asset_info_dict) {
            if ($.inArray(v, existForm) !== -1) {
              continue
            }
            this.formDynamicIndex++
            this.formDynamic.push({
              key: v,
              value: row.asset_info_dict[v],
              index: this.formDynamicIndex,
              status: 1,
              delete: true
            })
          }
        }
        if (row.supplier) {
          this.changeForm.supplier = row.supplier.id
        }
        this.changeModal = true
        this.tabPeopleValue = 'name1'
        this.tree1 = true
        this.tree2 = false
        this.changeModalTitle = '修改资产'
        console.log(this.changeForm)
      } else {
        this.$Notice.error({
          'title': '请选择资产！'
        })
      }
    },
    Delete () {
      if (this.selectRow) {
        let row = this.selectRow
        this.$Modal.confirm({
          title: '删除',
          content: '确定要删除编号「' + row.asset_id + '」资产吗?',
          onOk: () => {
            cmdbRequestApi.deleteOpsCenterAssets(row.id).then(res => {
              let result = res.data
              if (result.code === 500) {
                this.$Notice.error({
                  title: '操作失败！',
                  desc: result.msg
                })
              } else {
                this.$Notice.success({ title: '操作成功！' })
                this.getAssetsData()
              }
            }).catch(res => {
              if (res.request) {
                this.$Notice.error({
                  title: '操作失败！ 错误状态码:' + res.request.status,
                  desc: res.request.responseText
                })
              } else {
                this.$Notice.error({
                  title: '操作失败！服务器无响应'
                })
              }
            })
          }
        })
      } else {
        this.$Notice.error({
          title: '操作失败！请选择资产！'
        })
      }
    },
    getAllAssetType () {
      cmdbRequestApi.getOpsCenterAllAssetType().then(res => {
        this.allTypeData = res.data
        this.allTypeDataParent = res.data.filter(item => !item.parent)
        this.allTypeDataSon = res.data.filter(item => item.parent)
        this.allTypeDataSonExport = JSON.parse(JSON.stringify(res.data.filter(item => item.parent)))
        this.allTypeDataSonExport.map(item => {
          if (item.parent === 12) {
            item.name = '(行政物资)' + item.name
          } else if (item.parent === 16) {
            item.name = '(研发测试物资)' + item.name
          } else if (item.parent === 17) {
            item.name = '(IT物资)' + item.name
          } else if (item.parent === 18) {
            item.name = '(仓库物资)' + item.name
          } else if (item.parent === 19) {
            item.name = '(专项资金设备)' + item.name
          }
        })
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取所有资产类型列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取所有资产类型列表失败！服务器无响应'
          })
        }
      })
    },
    getAllSupplier () {
      cmdbRequestApi.getOpsCenterAllSupplier().then(res => {
        this.allSupplierData = res.data
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取所有供应商列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取所有供应商列表失败！服务器无响应'
          })
        }
      })
    },
    buyTimeChange (date) {
      this.changeForm.buy_time = date
    },
    formAdd () {
      this.formDynamicIndex++
      this.formDynamic.push({
        key: '',
        value: '',
        index: this.formDynamicIndex,
        status: 1,
        delete: true
      })
    },
    formRemove (index) {
      this.formDynamic[index].status = 0
    },
    assetTypeChange (value) {
      for (let i in this.formDynamic) {
        if (!this.formDynamic[i].delete) {
          this.formDynamic[i].status = 0
        }
      }
      if (value) {
        cmdbRequestApi.detailOpsCenterAssetType(value).then(res => {
          let result = res.data
          let customizeField = result.customize_asset_field.split(',')
          for (let v in customizeField) {
            this.formDynamic.push({
              key: customizeField[v],
              value: '',
              index: this.formDynamicIndex,
              status: 1,
              delete: false
            })
          }
        })
      }
    },
    assetTypeParentChange (value) {
      this.allTypeDataSon = this.allTypeData.filter(item => item.parent === value)
    },
    getSupplierData (value = 1) {
      this.supplier.page = value
      let params = {}
      params.size = this.supplier.size
      params.page = this.supplier.page
      this.supplierTableLoading = true
      cmdbRequestApi.getOpsCenterSupplier(params).then(res => {
        this.supplier.data = res.data.results
        this.supplier.count = res.data.count
        this.supplierTableLoading = false
      }).catch(res => {
        this.supplierTableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取供应商列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取供应商列表失败！服务器无响应'
          })
        }
      })
    },
    supplierChangeFormReset () {
      this.supplierChangeForm = {
        id: 0,
        name: '',
        contact: '',
        fixed_telephone: '',
        mobile_phone: '',
        address: '',
        email: '',
        qq: '',
        remark: ''
      }
    },
    supplierChangeSubmit () {
      this.$refs['supplierChangeForm'].validate((valid) => {
        if (valid) {
          cmdbRequestApi.changeOpsCenterSupplier(this.supplierChangeForm, this.supplierChangeForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getSupplierData()
            this.supplierChangeFormReset()
            this.supplierChangeModal = false
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    supplierChangeModalCancel () {
      this.supplierChangeFormReset()
      this.supplierChangeModal = false
    },
    supplierModifyOpen (row) {
      this.supplierChangeForm.id = row.id
      this.supplierChangeForm.name = row.name
      this.supplierChangeForm.contact = row.contact
      this.supplierChangeForm.fixed_telephone = row.fixed_telephone
      this.supplierChangeForm.mobile_phone = row.mobile_phone
      this.supplierChangeForm.address = row.address
      this.supplierChangeForm.email = row.email
      this.supplierChangeForm.qq = row.qq
      this.supplierChangeForm.remark = row.remark
      this.supplierChangeModal = true
    },
    supplierDelete (row) {
      cmdbRequestApi.deleteOpsCenterSupplier(row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getSupplierData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },

    typeChangeFormReset () {
      this.typeChangeForm.id = 0
      this.typeChangeForm.name = ''
      this.typeChangeForm.customize_asset_field = ''
    },
    typeModifyOpen (row) {
      this.typeChangeForm.id = row.id
      this.typeChangeForm.name = row.name
      this.typeChangeForm.customize_asset_field = row.customize_asset_field
      this.typeChangeModal = true
    },
    typeDelete (row) {
      cmdbRequestApi.deleteOpsCenterAssetType(row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getAssetTypeData()
        this.getAllAssetType()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    getAssetTypeData (value = 1) {
      this.type.page = value
      let params = {
        size: this.type.size,
        page: this.type.page
      }
      cmdbRequestApi.getOpsCenterAssetType(params).then(res => {
        this.type.data = res.data.results
        this.type.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取资产类型列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取资产类型列表失败！服务器无响应'
          })
        }
      })
    },
    typeChangeModalCancel () {
      this.typeChangeFormReset()
      this.typeChangeModal = false
    },
    typeChangeSubmit () {
      this.$refs['typeChangeForm'].validate((valid) => {
        if (valid) {
          cmdbRequestApi.changeOpsCenterAssetType(this.typeChangeForm, this.typeChangeForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getAssetTypeData()
            this.typeChangeFormReset()
            this.getAllAssetType()
            this.typeChangeModal = false
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },

    lendModalOpen () {
      if (this.selectRow) {
        this.lendForm.asset_id = this.selectRow.asset_id
      }
      this.lendModal = true
    },
    lendAction () {
      this.$refs['lendForm'].validate((valid) => {
        if (valid) {
          cmdbRequestApi.LendOpsCenterAsset(this.lendForm).then(res => {
            let result = res.data
            if (result.code === 200) {
              this.$Notice.success({
                title: '操作成功！'
              })
              this.getAssetsData()
              this.formReset('lendForm')
              this.lendModal = false
            } else {
              this.$Notice.error({
                title: '操作失败！',
                desc: result.msg
              })
            }
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },

    returnModalOpen () {
      if (this.selectRow) {
        if (this.selectRow.status === 1) {
          this.$Notice.error({
            title: '该资产目前为「在库」状态，不能归还！'
          })
          return
        }
        this.returnForm.asset_id = this.selectRow.asset_id
        this.returnForm.hand_person = this.selectRow.use_person
      }
      this.returnModal = true
    },
    returnAction () {
      this.$refs['returnForm'].validate((valid) => {
        if (valid) {
          cmdbRequestApi.ReturnOpsCenterAsset(this.returnForm).then(res => {
            let result = res.data
            if (result.code === 200) {
              this.$Notice.success({
                title: '操作成功！'
              })
              this.getAssetsData()
              this.formReset('returnForm')
              this.returnModal = false
            } else {
              this.$Notice.error({
                title: '操作失败！',
                desc: result.msg
              })
            }
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    maintainModalOpen () {
      if (this.selectRow) {
        this.maintainForm.asset_id = this.selectRow.asset_id
      }
      this.maintainModal = true
    },
    maintainAction () {
      this.$refs['maintainForm'].validate((valid) => {
        if (valid) {
          cmdbRequestApi.MaintainOpsCenterAsset(this.maintainForm).then(res => {
            let result = res.data
            if (result.code === 200) {
              this.$Notice.success({
                title: '操作成功！'
              })
              this.getAssetsData()
              this.formReset('maintainForm')
              this.maintainModal = false
            } else {
              this.$Notice.error({
                title: '操作失败！',
                desc: result.msg
              })
            }
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },

    scrapModalOpen () {
      if (this.selectRow) {
        this.scrapForm.asset_id = this.selectRow.asset_id
      }
      this.scrapModal = true
    },
    scrapAction () {
      this.$refs['scrapForm'].validate((valid) => {
        if (valid) {
          cmdbRequestApi.ScrapOpsCenterAsset(this.scrapForm).then(res => {
            let result = res.data
            if (result.code === 200) {
              this.$Notice.success({
                title: '操作成功！'
              })
              this.getAssetsData()
              this.formReset('scrapForm')
              this.scrapModal = false
            } else {
              this.$Notice.error({
                title: '操作失败！',
                desc: result.msg
              })
            }
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    getUsers () {
      GetALLUsers().then(res => {
        this.allUserData = res.data
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取用户列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取用户列表失败！服务器无响应'
          })
        }
      })
    },
    searchReset () {
      this.searchForm = {
        server_id: '',
        asset_type: '',
        supplier: '',
        status__in: [1, 2, 3],
        operator: '',
        use_person: '',
        asset_info: '',
        purchase_order: ''
      }
    },

    getAssetsCountData () {
      this.assetsCountTableLoading = true
      cmdbRequestApi.getOpsCenterAssetsCount().then(res => {
        this.assetsCount.data = res.data.data
        this.assetsCountTableLoading = false
      }).catch(res => {
        this.assetsCountTableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取资产统计数据失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取资产统计数据失败！服务器无响应'
          })
        }
      })
    },

    getAssetsFlowData (value = 1) {
      this.flow.page = value
      let params = this.flowSearchForm
      params.size = this.flow.size
      params.page = this.flow.page
      this.flowTableLoading = true
      cmdbRequestApi.getOpsCenterAssetFlow(params).then(res => {
        let result = res.data
        this.flow.data = result.results
        this.flowTableLoading = false
        this.flow.count = result.count
      }).catch(res => {
        this.flowTableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取出入库记录列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取出入库记录列表失败！服务器无响应'
          })
        }
      })
    },
    flowSearchReset () {
      this.flowSearchForm = {
        asset__asset_id: '',
        asset__asset_type: '',
        asset__supplier: '',
        asset__status: '',
        asset__asset_info: '',
        operator: '',
        hand_person: ''
      }
    },

    cutoverTab (name) {
      this.tabValue = name
    },

    revisionLog (id) {
      let params = {
        object_id: id,
        content_type: this.contentTypeId
      }
      cmdbRequestApi.getRevisionLogs(params).then(res => {
        this.RevisionLogs = res.data
      })
    },
    // 盘点方法
    getInventoryData (value = 1) {
      this.inventory.page = value
      this.inventory.page = value
      let params = {
        size: this.inventory.size,
        page: this.inventory.page
      }
      this.inventoryTableLoading = true
      cmdbRequestApi.getInventory(params).then(res => {
        this.inventory.data = res.data.results
        this.inventory.count = res.data.count
        this.inventoryTableLoading = false
      }).catch(res => {
        this.inventoryTableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取盘点列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取盘点列表失败！服务器无响应'
          })
        }
      })
    },
    inventoryChangeFormReset () {
      this.inventoryChangeForm = {
        inventory_asset_type: [],
        counting_people_obj: null,
        counting_people: null,
        counting_people_wechat_id: null,
        is_self_inventory: 0,
        explain: ''
      }
    },
    inventoryChangeSubmit () {
      this.$refs['inventoryChangeForm'].validate((valid) => {
        if (valid) {
          this.inventoryChangeForm.counting_people = this.inventoryChangeForm.counting_people_obj.map(item => item.label).join(',')
          this.inventoryChangeForm.counting_people_wechat_id = this.inventoryChangeForm.counting_people_obj.map(item => item.id).join(',')
          cmdbRequestApi.changeInventory(this.inventoryChangeForm).then(res => {
            if (res.data.code === 200) {
              this.$Notice.success({
                title: '操作成功！'
              })
              this.getInventoryData()
              this.inventoryChangeFormReset()
              this.inventoryChangeModal = false
            } else {
              this.$Message.error(res.data.msg)
            }
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    inventoryChangeModalCancel () {
      this.inventoryChangeFormReset()
      this.inventoryChangeModal = false
    },
    // 取消盘点
    inventoryCancel (row) {
      cmdbRequestApi.cancelInventory({ id: row.id }).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getInventoryData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 结束盘点
    inventoryOver (row) {
      cmdbRequestApi.overInventory({ id: row.id }).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getInventoryData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    exportCustomData () {
      this.$refs['exportForm'].validate((valid) => {
        if (valid) {
          this.exportCustomLoading = true
          let params = {
            type: this.exportForm.asset_type.join(',')
          }
          cmdbRequestApi.exportAssetCustom(params).then(res => {
            this.exportCustomLoading = false
            if (res.data.result.data_list.length > 0) {
              // 把返回数据的utc时间转换为当地时间
              // res.data.result.data_list.map(item => {
              //   item['领用时间'] = item['领用时间'] ? moment(item['领用时间']).format('YYYY-MM-DD HH:mm:ss') : ''
              // })
              const params = {
                title: res.data.result.field,
                key: res.data.result.field,
                data: res.data.result.data_list,
                autoWidth: true,
                filename: `自定义资产导出.csv`
              }
              excel.export_array_to_excel(params)
            } else {
              this.$Message.info('表格数据不能为空！')
            }
          }).catch(res => {
            this.exportCustomLoading = false
          })
        }
      })
    },
    exportTypeChange () {
      this.exportForm.columns = []
      this.exportForm.single = false
      this.tableColumnsSel = this.tableColumns
      let params = {
        type_id: this.exportForm.asset_type
      }
      cmdbRequestApi.getAssetFields(params).then(res => {
        if (res.data.result.length > 0) {
          // 将返回的附加信息字段加到主表上
          this.tableColumnsSel = this.tableColumns.concat(res.data.result)
        }
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 导出当前资产数据
    exportCurrentData () {
      this.exportLoading = true
      let params = JSON.parse(JSON.stringify(this.searchForm))
      params.asset_type = params.asset_type.length > 0 ? params.asset_type.join(',') : ''
      params.size = 5000
      cmdbRequestApi.exportAssetCurrent(params).then(res => {
        this.exportLoading = false
        if (res.data.data.data.length > 0) {
          // 把返回数据的utc时间转换为当地时间
          res.data.data.data.map(item => {
            item['领用时间'] = item['领用时间'] ? moment(item['领用时间']).format('YYYY-MM-DD HH:mm:ss') : ''
          })
          const params = {
            title: res.data.data.field,
            key: res.data.data.field,
            data: res.data.data.data,
            autoWidth: true,
            filename: `资产当前导出报表.csv`
          }
          excel.export_array_to_excel(params)
        } else {
          this.$Message.info('表格数据不能为空！')
        }
      }).catch(res => {
        this.exportLoading = false
      })
    },
    // 导出所有资产数据
    exportAllData () {
      this.exportLoading = true
      cmdbRequestApi.exportAssetAll().then(res => {
        this.exportLoading = false
        if (res.data.data.data.length > 0) {
          // 把返回数据的utc时间转换为当地时间
          res.data.data.data.map(item => {
            item['领用时间'] = item['领用时间'] ? moment(item['领用时间']).format('YYYY-MM-DD HH:mm:ss') : ''
          })
          const params = {
            title: res.data.data.field,
            key: res.data.data.field,
            data: res.data.data.data,
            autoWidth: true,
            filename: `所有资产导出.csv`
          }
          excel.export_array_to_excel(params)
        } else {
          this.$Message.info('表格数据不能为空！')
        }
      }).catch(res => {
        this.exportLoading = false
      })
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
